module.exports = __webpack_public_path__ + "img/donut-careers.64a239ca.svg";